import * as React from 'react';
import {GatsbyImage, IGatsbyImageData} from 'gatsby-plugin-image';

interface IImageHeader {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  image: IGatsbyImageData;
  alt?: string;
  titleClassName?: string;
}

export const ImageHeader = ({
  title,
  subtitle,
  children,
  image,
  alt,
  titleClassName,
}: IImageHeader) => {
  const titleWidth = titleClassName
    ? `${titleClassName}`
    : 'max-w-[28rem] md:max-w-[49rem] ';

  return (
    <div className="relative h-[49rem] md:h-[59rem] flex justify-center items-center bg-background">
      <GatsbyImage
        image={image}
        alt={alt ?? ''}
        loading="eager"
        objectFit="cover"
        objectPosition="center"
        style={{position: 'absolute', inset: 0}}
      />
      <div
        className={`relative flex flex-col px-5 md:px-12 w-full h-fit items-center ${titleWidth}`}>
        <h1 className="text-white text-h2mob md:text-h2 font-title py-4 text-center">
          {title}
        </h1>
        <h2 className="text-white text-largebodymob md:text-largebody font-body text-center pt-4">
          {subtitle}
        </h2>
        {children}
      </div>
    </div>
  );
};
